module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Please Login")]), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "form-item-icon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), _c('el-input', {
    attrs: {
      "value": _vm.form.username,
      "placeholder": "username"
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.form.username = $$v
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "form-item-icon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": _vm.passwordType,
      "placeholder": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.form.password = $$v
      },
      expression: "form.password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-item-icon show-password",
    on: {
      "click": _vm.showPassword
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Log In")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('div', {
    staticClass: "tip-content"
  }, [_vm._v("Username: leecason"), _c('br'), _vm._v("Password: any")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d4c3811","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 599
// module chunks = 1